export enum BtnColor {
  red = "red",
  green = "green",
  blue = "blue",
  azure = "azure",
}
